import { QueryKey, useQuery } from "react-query";
import useNetworkHeaders from "../../../hooks/useNetworkHeaders";
import { getNotifyCRMTopics } from "../../../queries/communications";

interface NotifyClassification {
  classification_id: number;
  city_id: number;
  classification_text: string;
}
export default function useNotifyCRMTopics() {
  const headers = useNetworkHeaders();

  const queryKey = getNotifyCRMTopicsQueryKey();
  const query = useQuery<{ data: NotifyClassification[] }>(queryKey, getNotifyCRMTopics(headers));

  return {
    data: query.data,
    isLoading: query.isLoading,
  };
}

function getNotifyCRMTopicsQueryKey(): QueryKey {
  return ["notify-crm-topics"];
}
